import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ActionMenuItemType } from '@client/ng2/shared/components/action-menu-panel/action-menu-panel.type';

@Component({
    selector: 'domain-group-action-menu-button',
    template: `
        @if (updating()) {
            <span class="fas fa-spinner fa-spin fa-3x"></span>
        } @else {
            <mon-action-menu [monActionMenuItems]="dropdowns()">
                <span translate>Action</span>
            </mon-action-menu>
        }
    `,
    standalone: true,
    imports: [
        MonActionMenuModule,
        TranslateModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DomainGroupActionMenuButtonComponent {
    translateService = inject(TranslateService);
    monModalService = inject(MonModalService);
    activeFeatureService = inject(ActiveFeatureService);
    pipeService = inject(PipeService);

    updating = input<boolean | undefined>(false);

    goToDomainGroup = output();
    editDomainGroup = output();
    updateSingleDomainGroup = output();
    confirmDeleteGroup = output();

    dropdowns = computed<ActionMenuItemType[]>((): ActionMenuItemType[] => {

        return [
            {
                label: this.translateService.getString('Open group'),
                leftIcon: 'faClone',
                action: () => this.goToDomainGroup.emit(),
                eventParams: { action: 'admin-domain-open-group' },
            },
            {
                label: this.translateService.getString('Edit domain group'),
                leftIcon: 'faCog',
                action: () => this.editDomainGroup.emit(),
                eventParams: { action: 'admin-domain-edit-group' },
            },
            {
                label: this.translateService.getString('Update domain group'),
                leftIcon: 'faRedoAlt',
                rightIcon: this.updating() ? 'faSpinner' : '',
                spinRightIcon: true,
                action: () => {
                    const message = this.translateService.getString(
                        'Updating a group can take more than 30 minutes. ' +
                                'During the operation you will not be able to create and update groups.',
                    );
                    this.monModalService.confirm(message, {})
                        .then(() => this.updateSingleDomainGroup.emit());
                },
                disabled: this.updating() ?? false,
            },
            {
                divider: true,
            },
            {
                label: this.translateService.getString('Remove domain group'),
                leftIcon: 'faTrashAlt',
                action: () => this.confirmDeleteGroup.emit(),
                eventParams: { action: 'admin-domain-remove-group' },
            },
        ];
    });
}
